import React, { useEffect, useState, Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  // Stage rendering: Hero paints first, below-the-fold mounts after first paint,
  // non-critical UI (popup) waits until browser is idle.
  const [mountBelowFold, setMountBelowFold] = useState(false);
  const [mountIdle, setMountIdle] = useState(false);
  useEffect(() => {
    // Mount below-the-fold sections on next animation frame to let LCP paint first
    const raf = requestAnimationFrame(() => setMountBelowFold(true));
    const w = window as any;
    let idleId: any;
    let idleTimer: any;
    if ('requestIdleCallback' in window) {
      idleId = w.requestIdleCallback(() => setMountIdle(true), {
        timeout: 4000
      });
    } else {
      idleTimer = setTimeout(() => setMountIdle(true), 3000);
    }
    return () => {
      cancelAnimationFrame(raf);
      if (idleId) w.cancelIdleCallback?.(idleId);
      if (idleTimer) clearTimeout(idleTimer);
    };
  }, []);
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-246">
      <div data-id="element-247">
        <HeroSection data-id="element-248" />

        {mountBelowFold && <>
            <Suspense fallback={null} data-id="element-249">
              <TrustBar data-id="element-250" />
              <ContrastSection data-id="element-251" />
              <ForWhomSection data-id="element-252" />
              <BenefitsSection data-id="element-253" />
              <ContentPreview data-id="element-254" />
              <BonusSection data-id="element-255" />
              <PricingSection data-id="element-256" />
            </Suspense>

            <Suspense fallback={null} data-id="element-257">
              <GuaranteeSection data-id="element-258" />
              <TestimonialsSection data-id="element-259" />
              <ExpertSection data-id="element-260" />
              <FAQSection data-id="element-261" />
              <Footer data-id="element-262" />
              <StickyCTA data-id="element-263" />
              {mountIdle && <SocialProofPopup data-id="element-264" />}
            </Suspense>
          </>}
      </div>
    </main>;
}